import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _ from 'lodash';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import urls from '../../../../utils/urls';
import Header from '../../../Header/index';
import {ajaxHandler} from '../../../../utils/errors';
import {tokenHeader} from '../../../../utils/headers';
import {Spinner} from '../../../../components/Loading/Spinner';
import helpers from '../../../../utils/helpers';


class HomeOperator extends Component {

    constructor(props) {
        super(props);

        this.state = {
            trip_type: helpers.trip_type.FE,
            pendingTrips: false,
            downloadTrips: false,
            lastsTrips: false,
            refreshing: true
        }
    }

    componentWillMount() {
        this._fetchShipments();
    }

    _fetchShipments = () => {
        const pendingTrips = `${urls.API_ROOT}/api/v1/operator-trip/new/`;
        const unloadTrips = `${urls.API_ROOT}/api/v1/operator-trip/in_progress/`;
        const lastTrips = `${urls.API_ROOT}/api/v1/operator-trip/finished/`;

        axios.all([
            axios.get(pendingTrips, tokenHeader()),
            axios.get(unloadTrips, tokenHeader()),
            axios.get(lastTrips, tokenHeader()),
        ])
            .then(axios.spread(function (pending, downloading, lasts) {
                return {
                    pendingTrips: pending.data,
                    downloadTrips: downloading.data,
                    lastsTrips: lasts.data
                }
            }))
            .then((data) => {
                this.setState({
                    pendingTrips: data.pendingTrips.slice(0, 2),
                    downloadTrips: data.downloadTrips.slice(0, 2),
                    lastsTrips: data.lastsTrips.slice(0, 5),
                    refreshing: false
                });
            })
            .catch(ajaxHandler);
    };

    _getTripData = (trips, columns) => {
        let data = [];
        if (trips && trips instanceof Array) {
            trips.forEach(trip => {
                let row = {id: trip.id};
                columns.forEach(col => {
                    row[col.dataField] = _.get(trip, col.path, '-');
                    if(!row[col.dataField] || row[col.dataField] === ''){
                        row[col.dataField] = '-';
                    }
                });
                data.push(row);
            });
        }
        return data
    };

    _getTripColumns = (columns) => {
        return columns.map(c => {
            return {text: c};
        })
    };

    _onTableChange = (type, { page, sizePerPage, filters }) => {
        this.setState({trips: false, page}, this._fetchShipments);
    };

    rowEvents = {
        onClick: (e, row, rowIndex) => {
            this.props.history.push(`/trips/${row.id}`);
        }
    };

    render() {

        let body = <div className={"margin-top-20"} ><Spinner /></div>;

        if(!this.state.refreshing){
            let pendingTrips = [
                {text: "Patente chasis", dataField: 'truck_plate', path: 'truck_plate'},
                {text: "Patente Acoplado", dataField: 'trailer_plate', path: 'trailer_plate'},
                {text: "Producto", dataField: 'product', path: 'product.name'},
                {text: "Nº Remito Proveedor", dataField: 'provider_trip_receipt', path: 'provider_trip_receipt'},
                {text: "Chofer", dataField: 'driver_name', path: 'driver_name'}
            ];

            let downloadingTrips = [
                {text: "Patente chasis", dataField: 'truck_plate', path: 'truck_plate'},
                {text: "Producto", dataField: 'product', path: 'product.name'},
                {text: "Isla / Meter", dataField: 'meter', path: 'discharge[0].meter.description'},
                {text: "Lts. Descargado", dataField: 'unload_volume', path: 'unload_volume'}
            ];

            let lastsTrips = [
                {text: "Patente chasis", dataField: 'truck_plate', path: 'truck_plate'},
                {text: "Producto", dataField: 'product', path: 'product.name'},
                {text: "Lts. Descargados", dataField: 'unload_volume', path: 'unload_volume'},
                {text: "Estado Final", dataField: 'status', path: 'status.name'},
                {text: "Motivo Rechazo", dataField: 'rejection_reason', path: 'rejection_reason.text'}
            ];

            body = (
                <div>
                    <div className={"margin-top-20"} >
                        <h4 className={"operator-titles"}>Pendientes</h4>
                        <div className={'main-table'}>
                            <BootstrapTable
                                remote
                                keyField='id'
                                classes={'striped highlight bordered custom-black-table'} bordered={false}
                                data={this._getTripData(this.state.pendingTrips, pendingTrips)}
                                columns={pendingTrips}
                                noDataIndication={()=>{return <p className={"center"}>No hay información disponible</p>}}
                                rowEvents={this.rowEvents}
                            />
                        </div>
                    </div>
                    <div className={"margin-top-20"} >
                        <h4 className={"operator-titles"}>En Descarga</h4>
                        <div className={'main-table'}>
                            <BootstrapTable
                                remote
                                keyField='id'
                                classes={'striped highlight bordered custom-black-table'} bordered={false}
                                data={this._getTripData(this.state.downloadTrips, downloadingTrips)}
                                columns={downloadingTrips}
                                noDataIndication={()=>{return <p className={"center"}>No hay información disponible</p>}}
                                rowEvents={this.rowEvents}
                            />
                        </div>
                    </div>
                    <div className={"margin-top-20"} >
                        <h4 className={"operator-titles"}>Descargados</h4>
                        <div className={'main-table'}>
                            <BootstrapTable
                                remote
                                keyField='id'
                                classes={'striped highlight bordered custom-black-table'} bordered={false}
                                data={this._getTripData(this.state.lastsTrips, lastsTrips)}
                                columns={lastsTrips}
                                noDataIndication={()=>{return <p className={"center"}>No hay información disponible</p>}}
                                rowEvents={this.rowEvents}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={'main-dashboard'}>
                <Header active={this.state.trip_type}/>
                {body}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch)
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeOperator));





// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/FE/HomeOperator.js